export function getContrastYIQ(hexcolor) {
    var r = parseInt(hexcolor.substring(1, 3), 16);
    var g = parseInt(hexcolor.substring(3, 5), 16);
    var b = parseInt(hexcolor.substring(5, 7), 16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? 'black' : 'white';
}

export function getLang() {
    let finalLanguage = navigator.language.substring(0, 2);

    // if no iframe, no Shopify, then get browser language
    if (navigator.languages != undefined) finalLanguage = navigator.languages[0].substring(0, 2);

    // if no iframe and Shopify - get language from Shopify.locale
    if (window.Shopify.locale) {
        finalLanguage = window.Shopify.locale;
    }

    // get lang from iframe first
    if (window.Progus?.lang) {
        finalLanguage = window.Progus.lang;
    }

    // return final language value
    if (finalLanguage === "zh-CN" || finalLanguage === "zh-TW") {
        finalLanguage = "zh";
    }
    return finalLanguage;
}
